import { Deployment } from 'sharebase/domain/deployment';

export class DeploymentFactory  {
	public static $inject = [
		'gettextCatalog'
	];

	constructor( private readonly gettextCatalog ){
    
    }
	
	public create(srvData?: any) {
        return new Deployment(this.gettextCatalog, srvData);
    }
}


// WEBPACK FOOTER //
// ./src/sharebase/factories/deploymentFactory.ts